/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Timeline_Outcome_UnfinishedInputs */



/**
* | output |
* | --- |
* | "still running" |
*
* @param {Chat_Timeline_Outcome_UnfinishedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_timeline_outcome_unfinished = /** @type {((inputs?: Chat_Timeline_Outcome_UnfinishedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Timeline_Outcome_UnfinishedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("lief noch")
	return /** @type {LocalizedString} */ ("still running")
});